import { ALIAS, COMMUNITY_SERVER_TYPE, FILTER_DATA, SEARCH_PARAMS, SERVICE_ALIAS } from "@constants/index";

// api url 가공
export const setApiUrl = (url: string, option: IOption, params?: {[key: string]: string}) => {
    const { serviceAlias, communityApi } = option || {};

    if(serviceAlias) {
        url = url?.replace(/\{serviceAlias\}/g, serviceAlias);
    }

    if(communityApi) {
        let api = communityApi;

        // Lineage2일 때 커뮤니티 api 별도 처리
        if(serviceAlias === SERVICE_ALIAS.LINEAGE2) {
            const server = params?.[SEARCH_PARAMS.SERVER];
            const path = server === COMMUNITY_SERVER_TYPE[SERVICE_ALIAS.LINEAGE2].L2AWKN ? COMMUNITY_SERVER_TYPE[SERVICE_ALIAS.LINEAGE2].L2AWKN : COMMUNITY_SERVER_TYPE[SERVICE_ALIAS.LINEAGE2].L2;
            api = new URL(`/${path}`, communityApi).toString();
            console.log("api", api)
        }

        if(params?.boardAlias) {
            url = url?.replace(/\{boardAlias\}/g, params?.boardAlias);
        }
        
        url = url?.replace(/\{communityApi\}/g, api);
    }

    return url;
};

// api - new URL 로 가공
export const setStrUrlToURL = (url: string, domain?: string | null) => {
    return domain ? new URL(url, domain) : new URL(url); 
};

// new URL().searchParams.entries() => [[key, value]] 로 변경
export const setArraySearchParams = (url: string): [string, string][] => {
    if(!url) {
        return [];
    }

    const hasQueryString = (/\?.+/).test(url);
    const searchParams = hasQueryString ? url.split('?')[1] : null;

    return searchParams ? Array.from(new URLSearchParams(searchParams)?.entries()) : [];
};

// router의 loader params => searchParams 추출 
export const setRequestToSearchParams = (request: any) => {
    if(!request) {
        return {};
    }

    const searchParamsEntries = setArraySearchParams(request?.url);
    let searchParams: {[key: string]: string} = {};

    searchParamsEntries.forEach(v => {
        const key = v[0];
        const value = v[1];

        if(key) {
            searchParams[key] = value;
        }
    });

    return searchParams;
};

// router의 loader params => searchParams 추출 
export const setSearchParamsToObj = (params: URLSearchParams | string) => {
    if(!params) {
        return null;
    }

    params = typeof params !== 'string' ? params?.toString() : params;

    const searchParamsEntries = setArraySearchParams(`?${params}`);
    let searchParams: {[key: string]: string} = {};

    searchParamsEntries.forEach(v => {
        const key = v[0];
        const value = v[1];

        if(key) {
            searchParams[key] = value;
        }
    });

    return searchParams;
};

// 탭 및 전체-더보기 등 초기 로딩 url 설정 (serviceAlias/alias 해당 필터 초기값 붙임)
interface IGetTabUrlParams {
    serviceAlias: string; 
    alias: string; 
    url: string; 
    searchParams: URLSearchParams | Record<string, string>;
}

// 필터 모든 초기값 반환
export const getInitialParams = (serviceAlias: string, alias: string) => {
    let params: {[key: string]: string} = {};

    if(serviceAlias) {
        const filterData = FILTER_DATA[serviceAlias][alias];

        for(let key in filterData) {
            if(Array.isArray(filterData[key])) {
                let value = filterData[key][0]?.value;
                value = typeof value === 'number' ? `${value}` : value || '';
                if(!!value) {
                    params[key] = value;
                }
            }
        }
    }

    return params;
};

export const getInitialUrl = ({ serviceAlias, alias, url, searchParams }: IGetTabUrlParams) => {
    let newSearchParams = new URLSearchParams();

    if(searchParams instanceof URLSearchParams) {
        const keyword = searchParams?.has(SEARCH_PARAMS.KEYWORD) ? searchParams?.get(SEARCH_PARAMS.KEYWORD) as string : '';
        newSearchParams.set(SEARCH_PARAMS.KEYWORD, keyword);

        // 탭/전체 - 더보기 url에 필터 모든 초기값 붙이기
        // if(serviceAlias) {
        //     const filterData = FILTER_DATA[serviceAlias][alias];

        //     for(let key in filterData) {
        //         if(Array.isArray(filterData[key])) {
        //             let value = filterData[key][0]?.value;
        //             value = typeof value === 'number' ? `${value}` : value;
        //             !!value && newSearchParams?.set(key, value);
        //         }
        //     }
        // }
        const initialParams = getInitialParams(serviceAlias, alias);
        for(let key in initialParams) {
            !!initialParams[key] && newSearchParams?.set(key, initialParams[key]);
        }

    } else {
        // Record<string, string>으로 오면 searchParams 대신 해당 값 바로 사용함(전체더보기-클래식가이드북 등)
        // 완성된 searchParams를 {}로 만들어서 넣음
        const keyword = searchParams[SEARCH_PARAMS.KEYWORD] || '';
        newSearchParams = new URLSearchParams(searchParams);
        newSearchParams.set(SEARCH_PARAMS.KEYWORD, keyword);
    }
    
    alias !== ALIAS.TAG && newSearchParams.set(SEARCH_PARAMS.PAGE, '1'); 

    return `${url}?${newSearchParams?.toString()}`;
};

// <strong>태그 등 문자열에서 제거
export const strReplaceUrl = (url: string) => {
    return url?.replace(/<(\/strong|strong)([^>]*)>/gi, '');
};